<template>
<div>
  <div :id="prefix"></div>
</div>
</template>

<script>
import flowplayer from "@flowplayer/player"
import HlsPlugin from "@flowplayer/player/plugins/hls"
import SpeedPlugin from "@flowplayer/player/plugins/speed"

flowplayer(HlsPlugin)
flowplayer(SpeedPlugin)

import "@flowplayer/player/flowplayer.css"

export default {
  name: "Player2",
  props: {
    prefix: String,
    token: String,
    poster: String,
    src: String,
  },
  data() {
    return {
      player: null
    }
  },
  mounted: function() {
    this.player = flowplayer("#" + this.prefix, {
      poster: this.poster,
      src: this.src,
      token: this.token,
      seekable: true,
      live: false,
      preload: 'auto',
      hls: {
        native: false,
        xhrSetup: function (xhr) { xhr.withCredentials = true }
      },
      speed: {
        options: [0.2, 0.5, 1, 2],
        labels: ["0.2x", "0.5x","1x", "2x"]
      },
      fas: {
        frame_rate: 29.97
      },
      qsel: {labels:['first', 'seconde', 'last']}
    });
    //console.log('src' + this.src);
    //console.log(this.player);
  }
}
</script>
